import React from 'react'
import CompanyLocationSelect from './CompanyLocationSelect'
import MultiSelect from './MultiSelect'
import { ILocation } from '@api/types'

interface MultiCompanyLocationSelectProps {
  values: ILocation[]
  onChange: (locations: ILocation[]) => void
  noTitle?: boolean
  onAdd?: (loc: ILocation) => void
  onRemove?: (locId: string) => void
  hideButton?: boolean
  disabledIds?: string[]
  loading?: boolean
  onClearAll?: () => void
  onSelectAll?: (locations: ILocation[]) => void
  selectAllTitle?: string
}

export default function MultiCompanyLocationSelect({
  values,
  onChange,
  noTitle,
  onAdd,
  onRemove,
  onClearAll,
  hideButton,
  disabledIds,
  loading,
  onSelectAll,
  selectAllTitle,
}: MultiCompanyLocationSelectProps) {
  const buttonProps = {
    minimal: true,
    iconName: 'plus',
    blue: true,
  }
  return (
    <MultiSelect
      title={noTitle ? undefined : 'Locations'}
      values={values.map((v) => (
        <span key={v.id}>{v.city}</span>
      ))}
      loading={loading}
      onClearAll={onClearAll}
      select={
        <CompanyLocationSelect
          hideButton={hideButton}
          multi
          value={null}
          btnText="Add Location"
          itemDisabled={(item) =>
            disabledIds
              ? !!values.find(({ id }) => item.id === id) ||
                !!disabledIds.find((id) => id === item.id)
              : !!values.find(({ id }) => item.id === id)
          }
          itemsQuantity={values.length}
          excludeItem={(item) => (disabledIds ? !!disabledIds.find((id) => id === item.id) : false)}
          selectAllTitle={selectAllTitle}
          onSelectAll={onSelectAll}
          onChange={(location) =>
            values.find(({ id }) => id === location.id)
              ? onRemove
                ? onRemove(location.id)
                : onChange(values.filter(({ id }) => id !== location.id))
              : onAdd
              ? onAdd(location)
              : onChange([...values, location])
          }
          {...{ buttonProps }}
        />
      }
      onRemove={
        onRemove
          ? (locationId) => onRemove(locationId)
          : (locationId) => onChange(values.filter((av) => av.id !== locationId))
      }
    />
  )
}
